export default "__VITE_ASSET__D2WMYIHW__"